export default __webpack_public_path__ + "static/media/varexe-farsi-logo-icon.a0829226.svg";